import { defineStore } from 'pinia';
import { LeadDto } from '@containex/portal-backend-dto';

interface LeadState {
    leads: LeadDto[];
    amount: number;
    amountNewLeads: number;
}

export const useLeadStore = defineStore('lead', {
    state: (): LeadState => ({
        leads: [],
        amount: 0,
        amountNewLeads: 0,
    }),
});
